import React, { useContext } from "react";
import Accordion from "react-bootstrap/Accordion";
import { useAccordionButton } from "react-bootstrap/AccordionButton";
import AccordionContext from "react-bootstrap/AccordionContext";
import clsx from "clsx";
import HashRow from "./HashRow";
import { RenderWhen } from "../../../../components";

type HashTableProps = {
  hashes: {
    sha1: string;
    sha256: string;
    md5: string;
    imphash?: string;
    sha512?: string;
    ssdeep?: string;
    tlsh?: string;
  };
};

const HashTableToggle = ({ eventKey }: { eventKey: string }) => {
  const { activeEventKey } = useContext(AccordionContext);
  const onTableToggle = useAccordionButton(eventKey);
  const isCurrentEventKey = activeEventKey === eventKey;

  return (
    <div
      className={clsx("hash-summary__toggle-trigger", {
        "hash-summary__toggle-trigger--expanded": isCurrentEventKey
      })}
      onClick={onTableToggle}
    >
      <span className="hash-summary__toggle-trigger-icon icon-chevron-down"></span>
      <span className="hash-summary__toggle-text">
        Show {isCurrentEventKey ? "Fewer" : "More"} Hashes
      </span>
    </div>
  );
};

const HashTable = ({ hashes }: HashTableProps) => (
  <Accordion bsPrefix="hash-summary">
    <HashRow hashName="sha1" hashValue={hashes.sha1} />
    <HashRow hashName="sha256" hashValue={hashes.sha256} />
    <Accordion.Collapse className="hash-summary__hidden-hashes" eventKey="0">
      <>
        <HashRow hashName="md5" hashValue={hashes.md5} />
        <RenderWhen condition={Boolean(hashes.imphash)}>
          <HashRow hashName="imphash" hashValue={hashes.imphash} />
        </RenderWhen>
        <RenderWhen condition={Boolean(hashes.sha512)}>
          <HashRow hashName="sha512" hashValue={hashes.sha512} />
        </RenderWhen>
        <RenderWhen condition={Boolean(hashes.ssdeep)}>
          <HashRow hashName="ssdeep" hashValue={hashes.ssdeep} />
        </RenderWhen>
        <RenderWhen condition={Boolean(hashes.tlsh)}>
          <HashRow hashName="tlsh" hashValue={hashes.tlsh} />
        </RenderWhen>
      </>
    </Accordion.Collapse>
    <HashTableToggle eventKey="0" />
  </Accordion>
);

export default HashTable;
